// components/ModalEtudiantsInactifs.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  UserX,
  RotateCcw,
  Trash2,
  Calendar,
  User,
  AlertTriangle,
  CheckCircle,
  X,
  Eye,
  Phone,
  Mail,
  IdCard
} from 'lucide-react';
import './ModalEtudiantsInactifs.css';

const ModalEtudiantsInactifs = ({ onClose, onRestaure }) => {
  const [etudiantsInactifs, setEtudiantsInactifs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [etudiantDetails, setEtudiantDetails] = useState(null);

  useEffect(() => {
    fetchEtudiantsInactifs();
  }, []);

  const fetchEtudiantsInactifs = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await axios.get('    https://vmi1977988.contaboserver.net/api2/etudiants/inactifs', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEtudiantsInactifs(res.data);
    } catch (err) {
      console.error('Erreur:', err);
      setMessage('❌ Erreur lors du chargement des étudiants inactifs');
    } finally {
      setLoading(false);
    }
  };

  const handleRestaurer = async (id) => {
    if (!window.confirm('✅ Êtes-vous sûr de vouloir restaurer cet étudiant ?\n\nIl redeviendra actif et visible dans la liste principale.')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.post(`     https://vmi1977988.contaboserver.net/api2/etudiants/${id}/restaurer`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setMessage('✅ Étudiant restauré avec succès');
      fetchEtudiantsInactifs();

      if (onRestaure) onRestaure();

      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error('Erreur:', err);
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur lors de la restauration'));
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const handleSupprimerDefinitivement = async (id) => {
    if (!window.confirm('⚠️ ATTENTION DANGER ⚠️\n\n🔴 Cette action est IRRÉVERSIBLE et DÉFINITIVE !\n\n❌ L\'étudiant et TOUTES ses données seront SUPPRIMÉES À JAMAIS\n❌ Cette action NE PEUT PAS être annulée\n\n👉 Êtes-vous ABSOLUMENT SÛR de vouloir continuer ?')) return;

    // Double confirmation
    const confirmation = prompt('Pour confirmer, tapez "SUPPRIMER" en majuscules :');
    if (confirmation !== 'SUPPRIMER') {
      alert('❌ Suppression annulée');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.delete(`     https://vmi1977988.contaboserver.net/api2/etudiants/${id}/definitivement`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setMessage('✅ Étudiant supprimé définitivement');
      fetchEtudiantsInactifs();

      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error('Erreur:', err);
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur lors de la suppression'));
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return 'N/A';
    const date = new Date(isoDate);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getNomComplet = (etudiant) => {
    return `${etudiant.prenom || ''} ${etudiant.nomDeFamille || ''}`.trim();
  };

  if (loading) {
    return (
      <div className="modal-overlay-inactifs">
        <div className="modal-loading">
          <div className="spinner"></div>
          <p>Chargement des étudiants inactifs...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay-inactifs" onClick={onClose}>
      <div className="modal-content-inactifs" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header-inactifs">
          <div className="header-left">
            <UserX size={28} className="header-icon" />
            <div>
              <h2>Étudiants Inactifs</h2>
              <p className="header-subtitle">{etudiantsInactifs.length} étudiant{etudiantsInactifs.length > 1 ? 's' : ''} désactivé{etudiantsInactifs.length > 1 ? 's' : ''}</p>
            </div>
          </div>
          <button onClick={onClose} className="btn-close-modal">
            <X size={24} />
          </button>
        </div>

        {/* Message */}
        {message && (
          <div className={`alert-message ${message.includes('✅') ? 'success' : 'error'}`}>
            {message.includes('✅') ? <CheckCircle size={20} /> : <AlertTriangle size={20} />}
            <span>{message}</span>
          </div>
        )}

        {/* Content */}
        <div className="modal-body-inactifs">
          {etudiantsInactifs.length === 0 ? (
            <div className="empty-state">
              <UserX size={64} className="empty-icon" />
              <h3>Aucun étudiant inactif</h3>
              <p>Tous les étudiants sont actuellement actifs dans le système</p>
            </div>
          ) : (
            <div className="etudiants-grid">
              {etudiantsInactifs.map((etudiant) => (
                <div key={etudiant._id} className="etudiant-card-inactif">
                  {/* En-tête de la carte */}
                  <div className="card-header-inactif">
                    <div className="etudiant-avatar">
                      {etudiant.image ? (
                        <img
                          src={`     https://vmi1977988.contaboserver.net${etudiant.image}`}
                          alt={getNomComplet(etudiant)}
                        />
                      ) : (
                        <User size={40} />
                      )}
                    </div>
                    <div className="etudiant-info-header">
                      <h3>{getNomComplet(etudiant)}</h3>
                      <span className="badge-inactif">
                        <AlertTriangle size={14} />
                        Inactif
                      </span>
                    </div>
                  </div>

                  {/* Informations principales */}
                  <div className="card-body-inactif">
                    <div className="info-row">
                      <Mail size={16} />
                      <span>{etudiant.email || 'N/A'}</span>
                    </div>
                    <div className="info-row">
                      <Phone size={16} />
                      <span>{etudiant.telephone || 'N/A'}</span>
                    </div>
                    {etudiant.cin && (
                      <div className="info-row">
                        <IdCard size={16} />
                        <span>CIN: {etudiant.cin}</span>
                      </div>
                    )}
                    {etudiant.filiere && (
                      <div className="info-row">
                        <span className="label-formation">Formation:</span>
                        <span className="value-formation">{etudiant.filiere}</span>
                      </div>
                    )}
                    {etudiant.anneeScolaire && (
                      <div className="info-row">
                        <Calendar size={16} />
                        <span>{etudiant.anneeScolaire}</span>
                      </div>
                    )}
                  </div>

                  {/* Informations de désactivation */}
                  <div className="card-deactivation-info">
                    <div className="deactivation-header">
                      <AlertTriangle size={14} />
                      <span>Informations de désactivation</span>
                    </div>
                    <div className="deactivation-details">
                      {etudiant.dateDesactivation && (
                        <div className="detail-item">
                          <strong>Date:</strong>
                          <span>{formatDate(etudiant.dateDesactivation)}</span>
                        </div>
                      )}
                      {etudiant.raisonDesactivation && (
                        <div className="detail-item">
                          <strong>Raison:</strong>
                          <span className="raison-text">{etudiant.raisonDesactivation}</span>
                        </div>
                      )}
                      {etudiant.desactivePar && (
                        <div className="detail-item">
                          <strong>Désactivé par:</strong>
                          <span>
                            {etudiant.desactivePar.nom} {etudiant.desactivePar.prenom}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="card-actions-inactif">
                    <button
                      onClick={() => handleRestaurer(etudiant._id)}
                      className="btn-action btn-restaurer"
                      title="Restaurer cet étudiant"
                    >
                      <RotateCcw size={16} />
                      <span>Restaurer</span>
                    </button>
                    <button
                      onClick={() => handleSupprimerDefinitivement(etudiant._id)}
                      className="btn-action btn-supprimer-def"
                      title="Supprimer définitivement (ATTENTION: irréversible!)"
                    >
                      <Trash2 size={16} />
                      <span>Supprimer</span>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="modal-footer-inactifs">
          <div className="footer-info">
            <AlertTriangle size={16} />
            <span>Les étudiants inactifs n'apparaissent pas dans les statistiques et listes principales</span>
          </div>
          <button onClick={onClose} className="btn-fermer">
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalEtudiantsInactifs;